/**
 * 이벤트 서비스
 */

import apiClient from './api';
import {
  Event,
  EventFilter,
  EventListResponse,
} from '../types/event';

export const eventService = {
  /**
   * 이벤트 목록 조회
   */
  async getEvents(filter: EventFilter = {}): Promise<EventListResponse> {
    const params = new URLSearchParams();
    
    if (filter.event_type) params.append('event_type', filter.event_type);
    if (filter.status) params.append('status', filter.status);
    if (filter.search) params.append('search', filter.search);
    if (filter.page) params.append('page', filter.page.toString());
    if (filter.limit) params.append('limit', filter.limit.toString());

    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: EventListResponse }>(`/admin/events?${params.toString()}`);
    // return response.data.data;

    // 임시: 더미 데이터 반환
    return {
      events: [],
      pagination: {
        current_page: 1,
        total_pages: 1,
        total_count: 0,
        limit: 20,
      },
    };
  },

  /**
   * 이벤트 상세 조회
   */
  async getEvent(id: number): Promise<Event> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: { event: Event } }>(`/admin/events/${id}`);
    // return response.data.data.event;

    throw new Error('Not implemented');
  },

  /**
   * 이벤트 등록
   */
  async createEvent(data: Partial<Event>): Promise<Event> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.post<{ data: { event: Event } }>('/admin/events', data);
    // return response.data.data.event;

    throw new Error('Not implemented');
  },

  /**
   * 이벤트 수정
   */
  async updateEvent(id: number, data: Partial<Event>): Promise<Event> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.put<{ data: { event: Event } }>(`/admin/events/${id}`, data);
    // return response.data.data.event;

    throw new Error('Not implemented');
  },

  /**
   * 이벤트 삭제
   */
  async deleteEvent(id: number): Promise<void> {
    // TODO: 백엔드 API 구현 후 연동
    // await apiClient.delete(`/admin/events/${id}`);

    throw new Error('Not implemented');
  },
};

